import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const getSubQuests = createAsyncThunk(
  'subquest/getSubQuests',
  async (params) => {
    const { query, currentPage, pageSize, sortBy, orderBy, typeIds } = params;

    let apiRoute = `/admin/sub-quests?CurrentPage=${currentPage}&PageSize=${pageSize}`;
    if (query) apiRoute += `&Query=${query}`;
    if (sortBy) apiRoute += `&sortBy=${sortBy}`;
    if (orderBy) apiRoute += `&orderBy=${orderBy}`;
    if (typeIds) {
      typeIds.forEach((typeId) => {
        apiRoute += `&typeIds=${typeId}`;
      });
    }

    try {
      const response = await axios.get(apiRoute);
      return response.data;
    } catch (error) {
      return error.message;
    }
  }
);

export const getSubQuestsByQuestId = async (questId) => {
  try {
    const response = await axios.get(`/admin/quests/${questId}/sub-quests`);
    return response.data;
  } catch (error) {
    return null;
  }
};

export const getSubQuestById = createAsyncThunk(
  'subquest/getSubQuestById',
  async ({ questId, subQuestId }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/admin/quests/${questId}/sub-quests/${subQuestId}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue({
        status: error.response.status,
        data: error.response.data,
      });
    }
  }
);

export const createVideoSubQuest = createAsyncThunk(
  'subquest/createVideoSubQuest',
  async ({ id, formData }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post(
        `admin/quests/${id}/sub-quests/videos`,
        formData,
        {
          onUploadProgress: (progressEvent) => {
            let percentComplete = progressEvent.loaded / progressEvent.total;
            percentComplete = parseInt(percentComplete * 100, 10);
            dispatch({
              type: 'subquest/setUploadProgress',
              payload: percentComplete,
            });
          },
        }
      );

      dispatch({
        type: 'subquest/setUploadProgress',
        payload: 0,
      });

      return {
        id,
        subQuest: response.data,
      };
    } catch (error) {
      return rejectWithValue({
        status: error.response.status,
        data: error.response.data,
      });
    }
  }
);

export const createInteractiveContentSubQuest = createAsyncThunk(
  'subquest/createInteractiveContentSubQuest',
  async ({ id, formData }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post(
        `admin/quests/${id}/sub-quests/interactive-videos`,
        formData,
        {
          onUploadProgress: (progressEvent) => {
            let percentComplete = progressEvent.loaded / progressEvent.total;
            percentComplete = parseInt(percentComplete * 100, 10);
            dispatch({
              type: 'subquest/setUploadProgress',
              payload: percentComplete,
            });
          },
        }
      );

      dispatch({
        type: 'subquest/setUploadProgress',
        payload: 0,
      });

      return {
        id,
        subQuest: response.data,
      };
    } catch (error) {
      return rejectWithValue({
        status: error.response.status,
        data: error.response.data,
      });
    }
  }
);

export const createQuizSubQuest = createAsyncThunk(
  'subquest/createQuizSubQuest',
  async ({ questId, quizSubQuest }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `admin/quests/${questId}/sub-quests/quizzes`,
        quizSubQuest,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      return {
        id: questId,
        subQuest: response.data,
      };
    } catch (error) {
      return rejectWithValue({
        status: error.response.status,
        data: error.response.data,
      });
    }
  }
);

export const updateSubQuestAction = createAsyncThunk(
  'subquest/updateSubQuest',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `admin/sub-quests/${id}`,
        { ...data, isPublished: data.isPublished === 'true' },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue({
        status: error.response.status,
        data: error.response.data,
      });
    }
  }
);

export const updateVideoSubQuest = createAsyncThunk(
  'subquest/updateVideoSubQuest',
  async ({ questId, subQuestId, formData }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.put(
        `admin/quests/${questId}/sub-quests/videos/${subQuestId}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (progressEvent) => {
            let percentComplete = progressEvent.loaded / progressEvent.total;
            percentComplete = parseInt(percentComplete * 100, 10);
            dispatch({
              type: 'subquest/setUploadProgress',
              payload: percentComplete,
            });
          },
        }
      );

      dispatch({
        type: 'subquest/setUploadProgress',
        payload: 0,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue({
        status: error.response.status,
        data: error.response.data,
      });
    }
  }
);

export const updateInteractiveContentSubQuest = createAsyncThunk(
  'subquest/updateInteractiveContentSubQuest',
  async ({ questId, subQuestId, formData }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.put(
        `admin/quests/${questId}/sub-quests/interactive-videos/${subQuestId}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (progressEvent) => {
            let percentComplete = progressEvent.loaded / progressEvent.total;
            percentComplete = parseInt(percentComplete * 100, 10);
            dispatch({
              type: 'subquest/setUploadProgress',
              payload: percentComplete,
            });
          },
        }
      );

      dispatch({
        type: 'subquest/setUploadProgress',
        payload: 0,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue({
        status: error.response.status,
        data: error.response.data,
      });
    }
  }
);

export const updateQuizSubQuest = createAsyncThunk(
  'subquest/updateQuizSubQuest',
  async ({ questId, subQuestId, quizSubQuest }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `admin/quests/${questId}/sub-quests/quizzes/${subQuestId}`,
        quizSubQuest,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue({
        status: error.response.status,
        data: error.response.data,
      });
    }
  }
);

export const removeSubQuest = createAsyncThunk(
  'subquest/removeSubQuest',
  async ({ questId, subQuestId }, { rejectWithValue }) => {
    try {
      await axios.delete(`/admin/quests/${questId}/sub-quests/${subQuestId}`);
      return subQuestId;
    } catch (error) {
      return rejectWithValue({
        status: error.response.status,
        data: error.response.data,
      });
    }
  }
);

export const detachSubQuestById = createAsyncThunk(
  'subquest/detachSubQuestById',
  async ({ courseId, questId, subQuestId }, { rejectWithValue }) => {
    try {
      await axios.delete(
        `admin/courses/${courseId}/quests/${questId}/sub-quests/${subQuestId}`
      );
      return subQuestId;
    } catch (error) {
      return rejectWithValue({
        status: error.response.status,
        data: error.response.data,
      });
    }
  }
);

export const attachSubQuestsByIds = createAsyncThunk(
  'subquest/attachSubQuestsByIds',
  async ({ courseId, questId, subQuestIds }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `admin/courses/${courseId}/quests/${questId}/sub-quests`,
        subQuestIds,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue({
        status: error.response.status,
        data: error.response.data,
      });
    }
  }
);

export const updateSubQuestOrderNo = createAsyncThunk(
  'subquest/updateSubQuestOrderNo',
  async ({ questId, subQuestId, newOrderNo }, { rejectWithValue }) => {
    try {
      await axios.put(
        `/admin/quests/${questId}/sub-quests/${subQuestId}`,
        newOrderNo,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      return true;
    } catch (error) {
      return rejectWithValue({
        status: error.response.status,
        data: error.response.data,
      });
    }
  }
);

export const createQuizSubQuestQuestions = createAsyncThunk(
  'subquest/createQuizSubQuestQuestions',
  async ({ questions }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`admin/questions`, questions, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return {
        questions: response.data,
      };
    } catch (error) {
      return rejectWithValue({
        status: error.response.status,
        data: error.response.data,
      });
    }
  }
);

export const updateQuizSubQuestQuestions = createAsyncThunk(
  'subquest/updateQuizSubQuestQuestions',
  async ({ subQuestId, questions }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `admin/questions/update-questions/${subQuestId}`,
        questions,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      return {
        questions: response.data,
      };
    } catch (error) {
      return rejectWithValue({
        status: error.response.status,
        data: error.response.data,
      });
    }
  }
);

export const createNarrativeSubQuest = createAsyncThunk(
  'subquest/createNarrativeSubQuest',
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `admin/quests/${id}/sub-quests/narrative`,
        formData,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      return {
        id,
        subQuest: response.data,
      };
    } catch (error) {
      return rejectWithValue({
        status: error.response.status,
        data: error.response.data,
      });
    }
  }
);

export const updateNarrativeSubQuest = createAsyncThunk(
  'subquest/updateNarrativeSubQuest',
  async ({ questId, subQuestId, formData }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `admin/quests/${questId}/sub-quests/narrative/${subQuestId}`,
        formData,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue({
        status: error.response.status,
        data: error.response.data,
      });
    }
  }
);

export const createFileSubmissionSubQuest = createAsyncThunk(
  'subquest/createFileSubmissionSubQuest',
  async ({ id, formData }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post(
        `admin/quests/${id}/sub-quests/file-submission`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (progressEvent) => {
            let percentComplete = progressEvent.loaded / progressEvent.total;
            percentComplete = parseInt(percentComplete * 100, 10);
            dispatch({
              type: 'subquest/setUploadProgress',
              payload: percentComplete,
            });
          },
        }
      );

      dispatch({
        type: 'subquest/setUploadProgress',
        payload: 0,
      });

      return {
        id,
        subQuest: response.data,
      };
    } catch (error) {
      return rejectWithValue({
        status: error.response.status,
        data: error.response.data,
      });
    }
  }
);

export const updateFileSubmissionSubQuest = createAsyncThunk(
  'subquest/updateFileSubmissionSubQuest',
  async ({ subQuestId, questId, formData }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.put(
        `admin/quests/${questId}/sub-quests/file-submission/${subQuestId}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (progressEvent) => {
            let percentComplete = progressEvent.loaded / progressEvent.total;
            percentComplete = parseInt(percentComplete * 100, 10);
            dispatch({
              type: 'subquest/setUploadProgress',
              payload: percentComplete,
            });
          },
        }
      );

      dispatch({
        type: 'subquest/setUploadProgress',
        payload: 0,
      });

      return {
        questId,
        subQuest: response.data,
      };
    } catch (error) {
      return rejectWithValue({
        status: error.response.status,
        data: error.response.data,
      });
    }
  }
);

export const getLatestFileSubmissionSession = createAsyncThunk(
  'subquest/fetchLatestFileSubmissionSession',
  async ({ courseId, questId, subQuestId, ownerId }, { rejectWithValue }) => {
    try {
      const url = ownerId
        ? `admin/file-submission-session/${courseId}/${questId}/${subQuestId}/${ownerId}`
        : `file-submission-session/${courseId}/${questId}/${subQuestId}`;

      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      return rejectWithValue({
        status: error.response.status,
        data: error.response.data,
      });
    }
  }
);

export const updateFileSubmissionSession = createAsyncThunk(
  'subquest/updateFileSubmissionSession',
  async ({ id, sessionData }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `admin/file-submission-session/${id}`,
        sessionData,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue({
        status: error.response.status,
        data: error.response.data,
      });
    }
  }
);

export const getRelatedCourseQuestBySubQuest = createAsyncThunk(
  'subquest/getRelatedCourseQuestBySubQuest',
  async ({ subQuestId }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `admin/sub-quests/${subQuestId}/courses`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue({
        status: error.response.status,
        data: error.response.data,
      });
    }
  }
);
